import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/dashboard";
import Sidebar from './components/sidebar';
import VerifyUser from "./pages/verifyuser";
import VerifyEmployee from "./pages/verifyemployee";
import Login from "./pages/login";
function App() {
  return (
    <BrowserRouter>
    <Routes>
    <Route path="/" element={<Login />} />
      <Route path="/dashboard/*" element=
      {
     <div className="flex">
      <Sidebar />
      <Dashboard />
     </div>
      } />
      <Route path="/verifyuser/:token" element={<VerifyUser />} />
        <Route path="/verifyemployee/:token" element={<VerifyEmployee />}
  />
  
    </Routes>
  </BrowserRouter>
  );
}

export default App;
